module.exports = __webpack_public_path__ + "static/media/cover.7df46280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/bruce/cover.jpg
// module id = 51
// module chunks = 0